import { render, staticRenderFns } from "./contact-us.vue?vue&type=template&id=1dead094&scoped=true"
import script from "./contact-us.vue?vue&type=script&lang=js"
export * from "./contact-us.vue?vue&type=script&lang=js"
import style0 from "./contact-us.vue?vue&type=style&index=0&id=1dead094&prod&lang=scss&scoped=true"
import style1 from "./contact-us.vue?vue&type=style&index=1&id=1dead094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dead094",
  null
  
)

export default component.exports